import React from 'react';
import {Card, CardContent, Typography, Box, CircularProgress} from '@mui/material';
import {formatDateTime} from 'util/helper';
import {useQuery} from '@tanstack/react-query';
import * as elemental_axios_client from '../../../util/elemental_axios_client';

const VariantTestCard = ({ variant }) => {
    const queryStats = useQuery({
        queryKey: ['variant-stats', variant.message_id, variant.id],
        queryFn: () => {
            return elemental_axios_client.get(`/stats/messages/${variant.message_id}/variants/${variant.id}`);
        }
    });

    return (
        <Card sx={{ mb: 2, '&:hover': { boxShadow: 3 } }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, flex: 1 }}>
                        {variant.subject || 'No Subject'}
                    </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 2 }}>
                    <Box>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Created At
                        </Typography>
                        <Typography variant="body2">
                            {formatDateTime(variant.created_at, 'MMM dd, yyyy hh:mm a')}
                        </Typography>
                    </Box>
                    
                    <Box>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Sent
                        </Typography>
                        <Typography variant="body2">
                            {queryStats.isLoading ? (
                                <CircularProgress size={16} />
                            ) : queryStats.isError ? (
                                '-'
                            ) : (
                                queryStats.data?.sent || 0
                            )}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default VariantTestCard;
